import script from "./TaskPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskPage.vue?vue&type=script&setup=true&lang=js"

import "./TaskPage.vue?vue&type=style&index=0&id=233bee92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-233bee92"]])

export default __exports__